console.log('Running country check script');

var SESSION_KEY = 'jw-ud';
var US_DOMAIN = 'us.jewelmer.com';
var DEFAULT_DOMAIN = 'jewelmer.com';
var API_KEY = '4ee36ace9e1d4d4ba17e304a2cb34e4c';

// TEST MODE: Set to a country code to test locally (e.g., 'US', 'PH', or null for live)
var TEST_COUNTRY = null;

function checkRedirect(countryCode) {
  var hostname = window.location.hostname;
  var isLocal =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.myshopify.com') ||
    hostname.endsWith('.shopifypreview.com');

  // Skip redirects if local/admin
  if (isLocal) return;

  if (countryCode === 'US') {
    if (hostname !== US_DOMAIN) {
      window.location.href = 'https://' + US_DOMAIN;
    }
  } else {
    if (hostname !== DEFAULT_DOMAIN) {
      window.location.href = 'https://' + DEFAULT_DOMAIN;
    }
  }
}

function initCountryCheck() {
  // If TEST_COUNTRY is set, use that instead of fetching from API
  if (TEST_COUNTRY) {
    console.log('TEST MODE: Using country:', TEST_COUNTRY);
    checkRedirect(TEST_COUNTRY);
    return;
  }

  var params = new URLSearchParams(window.location.search);
  if (params.has('vpn')) {
    checkRedirect(params.get('vpn'));
    return;
  }

  try {
    var cached = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    if (cached.country_code) {
      checkRedirect(cached.country_code);
      return;
    }
  } catch (e) {
    console.log('SessionStorage not available:', e.message);
  }

  fetch('https://api.ipgeolocation.io/ipgeo?apiKey=' + API_KEY)
    .then(function (res) {
      return res.json();
    })
    .then(function (resp) {
      var data = {
        ip: resp.ip,
        country_code: resp.country_code2,
        country_name: resp.country_name,
      };
      try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
      } catch (e) {
        console.log('Could not save to sessionStorage:', e.message);
      }
      checkRedirect(data.country_code);
    })
    .catch(function (error) {
      console.error('Country check API failed:', error);
      checkRedirect('PH');
    });
}

initCountryCheck();
